// import { CalculateServiceReq } from '@quick/go-api-types/services/calculate';
import { z } from 'zod';

// Mirrors CalculateServiceReq
export const schema = z.object({
  additional_data: z
    .object({
      coupon: z.string().optional(),
      order_no: z.string().optional(),
    })
    .optional(),
  additional_fields: z
    .record(
      z.union([
        // AdditionalMagnitude
        z.array(
          z.object({
            units: z.coerce.number(),
            unit_type: z.coerce.number(),
            dimensions: z.record(z.coerce.number()),
            sub_total: z.coerce.number().optional(),
            total: z.coerce.number(),
            order: z.coerce.number().optional(),
          })
        ),
        // Additional List
        z.array(
          z.object({
            units: z.coerce.number(),
            goods: z.string(),
            order: z.coerce.number().optional(),
          })
        ),
        // Additional text
        z.array(
          z.object({
            units: z.coerce.number(),
            text: z.string(),
            order: z.coerce.number().optional(),
          })
        ),
        //New Boolean
        z.array(
          z.object({
            units: z.coerce.number(),
            value: z.boolean(),
            order: z.coerce.number().optional(),
          })
        ),
        // Old Boolean
        // z.boolean(),
      ])
    )
    .optional(),
  cargo_type_id: z.coerce.number().min(1),
  city_id: z.coerce.number().min(0),
  country_id: z.coerce.number().min(0),
  dates: z.array(
    z.object({
      date_time: z.coerce.date(),
      // uuid: z.string(),
    })
  ),
  declared_value: z.coerce.number().optional(),
  merchandise_description: z.string().optional(),
  modality_id: z.coerce.number().min(1),
  programmed: z.boolean(),
  round_trip: z.boolean().optional(),
  service_type_id: z.coerce.number().min(1),
  stops: z
    .array(
      z.object({
        address: z.string().optional(),
        assistants: z.coerce.number().optional(),
        city_id: z.coerce.number().gt(0),
        // This two can cause problems.
        latitude: z.coerce.number().optional(),
        longitude: z.coerce.number().optional(),
        // This two are added to the address before sending to the API
        zip: z.string().optional(),
        city_name: z.string().optional(),

        name: z.enum(['Stop']),
        description: z.string().optional(),
        type_stop_id: z.coerce.number().optional(),
        area_geo: z.string(),
        // uuid: z.string(),
      })
    )
    .min(1),
  transport_conditions: z.string().optional(),
  uom: z.union([z.literal('metric'), z.literal('us')]).optional(),
  user_id: z.coerce.number().min(1),
  vehicle_type_id: z.coerce.number().optional(),
  worker_quantity: z.coerce.number(),
  worker_money: z.coerce.number().min(0).max(0),
  line_id: z.coerce.number().min(1),
  package_stops: z.record(z.string()),
});
